<template>
  <div class="hamburger-menu" :class="{'open':menuOpen}" @click="onMenuClick" >
    <transition mode="out-in">
      <div class="icon close" v-if="menuOpen"></div>
      <HamburgerMenuIcon v-else />
    </transition>
  </div>
</template>

<script>
import HamburgerMenuIcon from '@/assets/svg/hamburger.svg'

export default {
  name: 'HamburgerMenu',

  components: {
    HamburgerMenuIcon
  },

  props: {
    menuOpen: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    onMenuClick () {
      this.$emit('menu:toggle')
      // ...
    }
  }
}
</script>

<style scoped lang="scss">

.hamburger-menu {
  cursor: pointer;

  display: table;
  float: right;
  transition: transform 0.25s;
  transform-origin: right;

  &:hover {
    transform: scale(0.8, 1);
  }

  &.open {
    transform: none;
  }
}

.close {
  position: absolute;
  right: 24px;
  top: 16px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
  transition: opacity 0.5s;

  @include breakpoint('sm-and-down') {
    width: 20px;
    height: 20px;
  }
}

.close:hover {
  opacity: 1;
}

.close::before,
.close::after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: $c-white;

  @include breakpoint('sm-and-down') {
    height: 20px;
    width: 1px;
  }
}

.close::before {
  transform: rotate(45deg);
}

.close::after {
  transform: rotate(-45deg);
}

</style>
